export default "__VITE_ASSET__22KHsvfd__"